import axios from 'axios'
import { getApiToken } from './wireApiClient'

export const publishingApiClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLISHING_API_URL ?? 'https://publishing-api-rewire.com',
  headers: { 'Content-Type': 'application/json' },
})

publishingApiClient.interceptors.request.use((config) => {
  const token = getApiToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
